import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13} fill="none" {...props}>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m3.886 9.11-3.3 3.3m5.236-8.536-.91.91a1.227 1.227 0 0 1-.155.142.583.583 0 0 1-.12.064c-.048.02-.1.03-.203.05l-2.137.428c-.556.11-.834.166-.964.313a.583.583 0 0 0-.141.467c.027.194.227.394.628.795l4.133 4.133c.4.4.601.601.795.628a.583.583 0 0 0 .467-.142c.147-.13.202-.407.313-.963l.428-2.137c.02-.103.03-.155.05-.203a.583.583 0 0 1 .064-.12c.03-.043.067-.08.141-.154l.91-.91c.048-.048.072-.072.098-.093a.583.583 0 0 1 .073-.05c.03-.016.06-.03.122-.056l1.455-.623c.424-.182.637-.273.733-.42a.584.584 0 0 0 .084-.436c-.035-.172-.198-.336-.525-.662l-3-3c-.327-.327-.49-.49-.662-.525a.583.583 0 0 0-.436.084c-.147.096-.238.309-.42.733L6.02 3.582a1.21 1.21 0 0 1-.057.122.584.584 0 0 1-.05.073c-.02.026-.044.05-.091.097Z"
    />
  </svg>
);
export { SvgComponent as IndexPinIcon };
